import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { CalendarSource, CalendarSourceType } from '../data/calendar-source.interface';
import { FriendlySourceLabelPipe } from './friendly-source-label.pipe';
import { FriendlySourceTypePipe } from './friendly-source-type.pipe';

const EDITABLE_SOURCES = Object.values(CalendarSourceType);

@Pipe({
  standalone: false,
  name: 'friendlySourceTooltip',
})
export class FriendlySourceTooltipPipe implements PipeTransform {
  constructor(
    private datePipe: DatePipe,
    private friendlySourceNamePipe: FriendlySourceLabelPipe,
    private friendlySourceTypePipe: FriendlySourceTypePipe
  ) {}

  transform(source: CalendarSource): string {
    if (!source) {
      return '';
    }

    if (source.source === 'none') {
      return `We don't have ${this.friendlySourceTypePipe.transform(
        source
      )} data for this period. You can set it manually.`;
    }

    if (source.source === 'multiple') {
      return 'The current date range includes dates that have different sources. To reveal the source, select a smaller date range or a single day.';
    }

    if (EDITABLE_SOURCES.includes(source.type)) {
      return `Your ${this.friendlySourceTypePipe.transform(
        source
      )} was last changed from ${this.friendlySourceNamePipe.transform(source.source)} ${
        source.date ? ' on ' + this.datePipe.transform(this.convertUTCToLocal(source.date), 'long') : ''
      }`;
    }

    return '';
  }

  convertUTCToLocal(dateStr: string): Date {
    const date = new Date(dateStr + 'Z');
    return date;
  }
}
